import { graphlib, layout } from "@dagrejs/dagre";
import { Edge as FlowEdge, Node as FlowNode } from "@xyflow/react";

const nodeConfigMap: Record<string, { height: number }> = {
  trigger: { height: 100 },
  sendMessage: { height: 300 },
  recover: { height: 400 },
};

export const getLayoutedElements = (nodes: FlowNode[], edges: FlowEdge[]) => {
  const g = new graphlib.Graph({}).setDefaultEdgeLabel(() => ({}));

  g.setGraph({ rankdir: "TB", ranksep: 105, nodesep: 300 });

  for (const edge of edges) g.setEdge(edge.source, edge.target);

  for (const node of nodes) {
    const height = nodeConfigMap[node.type ?? ""]?.height ?? 105;
    g.setNode(node.id, { width: 0, height });
  }

  layout(g);

  const layoutedNodes = nodes.map((node: any) => {
    const height = nodeConfigMap[node.type ?? ""]?.height ?? 105;
    const offset = height / 2;

    const position = g.node(node.id);
    const x = position.x;
    const y = position.y - offset;

    return { ...node, position: { x, y } };
  });

  return { nodes: layoutedNodes, edges };
};
